function initPlayer(playerNode) {
    var hyperlinkNode = playerNode.querySelector('a');
    if (!hyperlinkNode) {
        return;
    }
    hyperlinkNode.addEventListener('click', function (event) {
        event.preventDefault();
        playerNode.classList.toggle('bg-orange');
    });
}
export function KMMPlayerPickerInit() {
    var playerNodes = Array.from(document.querySelectorAll("[data-js-selector='kmm-player']"));
    playerNodes.forEach(function (playerNode) {
        initPlayer(playerNode);
    });
    if (playerNodes.length) {
        // window.onbeforeunload = function() {
        // return "Data will be lost if you leave the page, are you sure?";
        // };
    }
}
